// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyB2VJ-Pis4ckx8-g8xGtMzNxxeuRmIVYKQ",
  authDomain: "fecu-48329.firebaseapp.com",
  projectId: "fecu-48329",
  storageBucket: "fecu-48329.firebasestorage.app",
  messagingSenderId: "750717603929",
  appId: "1:750717603929:web:034f6d22dda5844cb3a148"
}; 